import "./WizardHeader.scss";

interface StepActiveProps {
  hideMobilClass: string;
  stepNumber: number;
  text: string;
}

const StepActive = ({ hideMobilClass, stepNumber, text }: StepActiveProps) => {
  return (
    <div className={`stepItem${hideMobilClass ? ` ${hideMobilClass}` : ""}`}>
      <div className="stepItemBox stepItemBoxActive">
        {stepNumber.toString()}
      </div>
      <div className="stepItemText">{text}</div>
    </div>
  );
};

export default StepActive;
